import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
    selector: 'app-elementary-school-shortcuts',
    templateUrl: './elementary-school-shortcuts.component.html',
    styleUrls: ['./elementary-school-shortcuts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, MatIconModule, MatTooltipModule]
})
export class ElementarySchoolShortcutsComponent {

  @Input() isTeacherOrEducatorStaffMember: boolean;
  @Input() isTeacherStaffMember: boolean;
  @Input() isStaffMember: boolean;
}
